import React from "react";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

const Star = ({ value, reviewTotalCount, alignLeft }) => {
  const stars = [];

  for (let i = 1; i <= 5; i++) {
    if (value >= i) {
      stars.push(<FaStar key={i} color="#ffc107" />); // full star
    } else if (value >= i - 0.5) {
      stars.push(<FaStarHalfAlt key={i} color="#ffc107" />); // half star
    } else {
      stars.push(<FaRegStar key={i} color="#ffc107" />); // empty star
    }
  }

  return <div style={{ display: "flex", gap: "4px", alignItems: "center", justifyContent: alignLeft }}>{stars}{reviewTotalCount}</div>;
};

export default Star;
